import * as React from "react";

import {View} from "@khanacademy/wonder-blocks-core";
import {Strut} from "@khanacademy/wonder-blocks-layout";
import {spacing} from "@khanacademy/wonder-blocks-tokens";
import {HeadingMedium} from "@khanacademy/wonder-blocks-typography";

import MappingBreadcrumbs from "./mapping-breadcrumbs.tsx";

type Props = {
    countrySlug: string;
    domainIcon: React.ReactElement;
    domainTitle: string;
    regionIds: Array<string> | null | undefined;
};

export const StandardsNavHeader = ({
    countrySlug,
    domainIcon,
    domainTitle,
    regionIds,
}: Props): React.ReactElement => (
    <View>
        <MappingBreadcrumbs countrySlug={countrySlug} regionIds={regionIds} />
        <Strut size={spacing.xSmall_8} />
        <View style={styles.cardHeading}>
            {domainIcon}
            <Strut size={spacing.xSmall_8} />
            <HeadingMedium>{domainTitle}</HeadingMedium>
        </View>
    </View>
);

const styles = {
    cardHeading: {
        flexShrink: 0,
        flexDirection: "row",
        alignItems: "center",
    },
} as const;
